import * as React from 'react';

interface Props {
    title?: string;
    view?: string;
    changeView?: (e) => void;
    doRefresh: (e) => void;
}

export class FilterMenu extends React.Component<Props> {
    render() {
        let layout = null;
        if (this.props.view && this.props.changeView) {
            layout = (this.props.view === 'items' ? 'list' : 'grid') + ' layout icon';
        }

        return (<div className='ui secondary menu'>
                    {this.props.title && (<div className='item'><h1>{this.props.title}</h1></div>)}
                    <div className='right menu'>
                        {layout && <div className='item'>
                            <button className='ui icon button' onClick={this.props.changeView}>
                                <i className={layout}></i>
                            </button>
                        </div>}
                        {this.props.doRefresh && <div className='item'>
                            <button className='ui icon button' onClick={this.props.doRefresh}>
                                <i className='refresh icon'></i>
                            </button>
                        </div>}
                    </div>
                </div>);
    }
};



// WEBPACK FOOTER //
// ./src/components/common/filter/filter-menu.presentation.tsx